export function authHeader(jwtToken) {
  // return authorization header with jwt token
  if (jwtToken) {
    return { Authorization: `Bearer ${jwtToken}` };
  } else {
    return {};
  }
}
